'use strict';

import ApiEndpoint from './api_endpoint';

export default class UpdateChild extends ApiEndpoint {
  execute(callback = undefined, session = undefined, externalIdentifier = '', params = undefined) {
    if (session === undefined) {
      return this.session.put('/people/' + externalIdentifier + '/update_child', params, callback);
    }
    return session.put('/people/' + externalIdentifier + '/update_child', params, callback);
  }
}
